import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './shared/guard/auth.guard';
import { RoleGuard } from './shared/guard/role.guard';
import { Role } from './shared/_helpers/models/role';
import { PageNotFoundComponent } from './authentication/page-not-found/page-not-found.component';

const routes: Routes = [
	{
		path: '',
		redirectTo: 'app',
		pathMatch: 'full'
	},
	{
		path: 'app',
		loadChildren: () => import('./website/website.module').then(m => m.WebsiteModule) //website
	},
	{
		path: 'authentication',
		loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule) //login
	},
	{
		path: 'home',
		loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
		canActivate: [AuthGuard, RoleGuard],
		data: {
			routingModule: 'dashboard',
			roles: [Role.PORTAL_ADMIN, Role.CUSTOMER_ADMIN, Role.ROLE_PM, Role.ROLE_VENDOR]
		}
	},
	{
		path: 'property',
		loadChildren: () => import('./property/property.module').then(m => m.PropertyModule),
		canActivate: [AuthGuard, RoleGuard],
		data: {
			routingModule: 'property',
			roles: [Role.PORTAL_ADMIN, Role.CUSTOMER_ADMIN, Role.ROLE_PM]
		}
	},
	{
		path: 'qs-inspection',
		loadChildren: () => import('./qsi/qsi.module').then(m => m.QsiModule),
		canActivate: [AuthGuard, RoleGuard],
		data: {
			routingModule: 'qs_inspection',
			roles: [Role.PORTAL_ADMIN, Role.CUSTOMER_ADMIN, Role.ROLE_PM, Role.ROLE_VENDOR,
			Role.ROLE_BMV, Role.ROLE_RMV, Role.ROLE_LV]
		}
	},
	{
		path: 'rfp-management',
		loadChildren: () => import('./rfp-management/rfp-management.module').then(m => m.RfpManagementModule),
		canActivate: [AuthGuard, RoleGuard],
		data: {
			routingModule: 'rfp_management',
			roles: [Role.PORTAL_ADMIN, Role.CUSTOMER_ADMIN, Role.ROLE_PM, Role.ROLE_VENDOR]
		}
	},
	{
		path: 'configuration',
		loadChildren: () => import('./configuration/configuration.module').then(m => m.ConfigurationModule),
		canActivate: [AuthGuard, RoleGuard],
		data: {
			routingModule: 'configuration',
			roles: [Role.PORTAL_ADMIN]
		}
	},
	{
		path: 'reports',
		loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule),
		canActivate: [AuthGuard, RoleGuard],
		data: {
			routingModule: 'reports',
			roles: [Role.PORTAL_ADMIN, Role.CUSTOMER_ADMIN, Role.ROLE_PM, Role.ROLE_VENDOR]
		}
	},
	{
		path: 'user',
		loadChildren: () => import('./user/user.module').then(m => m.UserModule),
		canActivate: [AuthGuard, RoleGuard],
		data: {
			routingModule: 'user',
			roles: [Role.PORTAL_ADMIN, Role.CUSTOMER_ADMIN, Role.ROLE_PM]
		}
	},
	{
		path: 'crew',
		loadChildren: () => import('./crew/crew.module').then(m => m.CrewModule),
		canActivate: [AuthGuard, RoleGuard],
		data: {
			routingModule: 'crew',
			roles: [Role.ROLE_VENDOR]
		}
	},
	{
		path: 'customer',
		loadChildren: () => import('./customer/customer.module').then(m => m.CustomerModule),
		canActivate: [AuthGuard, RoleGuard],
		data: {
			routingModule: 'customer',
			roles: [Role.PORTAL_ADMIN]
		}
	},
	{
		path: 'vendor',
		loadChildren: () => import('./vendor/vendor.module').then(m => m.VendorModule),
		canActivate: [AuthGuard, RoleGuard],
		data: {
			routingModule: 'vendor',
			roles: [Role.PORTAL_ADMIN, Role.CUSTOMER_ADMIN, Role.ROLE_PM, Role.ROLE_VENDOR, Role.ROLE_BMV, Role.ROLE_RMV]
		}
	},
	{
		path: 'history',
		loadChildren: () => import('./history/history.module').then(m => m.HistoryModule),
		canActivate: [AuthGuard, RoleGuard],
		data: {
			routingModule: 'history',
			roles: [Role.PORTAL_ADMIN]
		}
	},
	{
		path: 'work-order',
		loadChildren: () => import('./work-order/work-order.module').then(m => m.WorkOrderModule),
		canActivate: [AuthGuard, RoleGuard],
		data: {
			routingModule: 'work_order',
			roles: [Role.ROLE_VENDOR, Role.ROLE_PM]
		}
	},
	{
		path: 'view',
		loadChildren: () => import('./view-data/view-data.module').then(m => m.ViewDataModule),
		canActivate: [AuthGuard, RoleGuard],
		data: {
			routingModule: 'view_data',
			roles: [Role.PORTAL_ADMIN, Role.CUSTOMER_ADMIN, Role.ROLE_PM]
		}
	},
	{
		path: 'region-branch',
		loadChildren: () => import('./region-branch/region-branch.module').then(m => m.RegionBranchModule),
		canActivate: [AuthGuard, RoleGuard],
		data: {
			routingModule: 'region_branch',
			roles: [Role.PORTAL_ADMIN, Role.CUSTOMER_ADMIN]
		}
	},
	{
		path: 'extra-work-task',
		loadChildren: () => import('./extra-work-task/extra-work-task.module').then(m => m.ExtraWorkTaskModule),
		canActivate: [AuthGuard, RoleGuard],
		data: {
			routingModule: 'extra_work_task',
			roles: [Role.PORTAL_ADMIN, Role.CUSTOMER_ADMIN, Role.ROLE_PM, Role.ROLE_VENDOR, Role.ROLE_BMV, Role.ROLE_RMV]
		}
	},
	{
		path: '**',
		component: PageNotFoundComponent
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
